var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadiologistIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4152 2.36842H25.4999V6.14273H30.2541V13.251C30.2541 19.4944 24.4373 24.574 17.288 24.574C10.1386 24.574 4.32199 19.4945 4.32199 13.2511V6.14273H8.93218V2.36842H2.161C0.967395 2.36842 0 3.21323 0 4.25558V13.2511C0 21.576 7.75512 28.3484 17.2881 28.3484C26.8211 28.3484 34.5762 21.576 34.5762 13.2511V4.25558C34.5762 3.21323 33.6088 2.36842 32.4152 2.36842Z",
    fill: "#214A66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8384 29.921V38.8536C40.8384 44.0565 35.9913 48.2894 30.0333 48.2894C24.0754 48.2894 19.2282 44.0565 19.2282 38.8536V26.5241H14.9062V38.8536C14.9062 46.1374 21.6918 52.0637 30.0333 52.0637C38.3741 52.0637 45.1604 46.1374 45.1604 38.8536V29.921H40.8384Z",
    fill: "#214A66"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0043 17.7172C38.5944 17.7172 35.0078 20.8493 35.0078 24.6998C35.0078 28.5496 38.5944 31.6823 43.0036 31.6823C47.4128 31.6823 50.9994 28.5496 51.0001 24.6998C51 20.8493 47.4128 17.7172 43.0043 17.7172ZM43.0036 27.908C40.9773 27.908 39.3291 26.4688 39.3291 24.6999C39.3291 22.931 40.9772 21.4917 43.0036 21.4917C45.0292 21.4917 46.6773 22.931 46.6773 24.6999C46.6773 26.4688 45.0292 27.908 43.0036 27.908Z",
    fill: "#214A66"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.85631 0.355545C7.66271 0.355545 6.69531 1.20035 6.69531 2.2427V6.26867C6.69531 7.31102 7.66271 8.15583 8.85631 8.15583C10.0499 8.15583 11.0173 7.31102 11.0173 6.26867V2.2427C11.0173 1.20035 10.0499 0.355545 8.85631 0.355545Z",
    fill: "#214A66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5751 0.355545C24.3815 0.355545 23.4141 1.20035 23.4141 2.2427V6.26867C23.4141 7.31102 24.3815 8.15583 25.5751 8.15583C26.7687 8.15583 27.7361 7.31102 27.7361 6.26867V2.2427C27.7361 1.20035 26.7687 0.355545 25.5751 0.355545Z",
    fill: "#214A66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadiologistIcon);
export default __webpack_public_path__ + "static/media/radiologist-icon.cf61ce8d93452a404b2d26789ac1d0e0.svg";
export { ForwardRef as ReactComponent };